import FeedbackPage from '@/components/FeedbackPage'
import { ShieldCheckIcon } from '@heroicons/react/24/outline'

export default function PreventionIntroPage() {
  return (
    <FeedbackPage
      icon={<ShieldCheckIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.preventionIntro.heading"
      descriptionKey="pages.onboarding.preventionIntro.description"
    />
  )
}
